import {useState} from "react";
import {TaskData} from "./TaskData.jsx";

import 'reactjs-popup/dist/index.css';
import {IconButton} from "./IconButton.jsx";
import {BiEdit} from "react-icons/bi";
import {Col, Row} from "react-bootstrap";
import {MdDelete} from "react-icons/md";
import {IfAdmin, IfLoggedIn} from "../../ifLoggedIn";
import {useCalendarDataMutations} from "../../../api/calendardatasapi";
import {BasePopup} from "../../grouping/BasePopup";
import {CalendarTaskForm} from "../../forms/CalendarTaskForm";


const taskNoteStyle = {
    contentStyle: {background: '#fffbfb', borderRadius: '10px'},
    overlayStyle: {background: 'rgba(223,229,229,0.29)', overflowY: 'auto'},
    arrowStyle: {color: '#000'}
}

export function TaskNote(props) {
    const {task, children, onOpenChange, onTaskEditingChange} = props
    const [open, setIsOpen] = useState(false);
    const [openEdit, setIsOpenEdit] = useState(false);
    return <button className={"p-0 m-0 text-start border-0 bg-transparent w-100"} onClick={(event) => {
        event.preventDefault();
        setIsOpen(true);
    }}>
        {children}
        <BasePopup open={open} onOpenChange={setIsOpen}
                   children={<TaskPopUpData openEdit={openEdit} setIsOpenEdit={setIsOpenEdit}
                                            onTaskEditingChange={onTaskEditingChange} onOpenEditChange={onOpenChange}
                                            task={task}/>}/>
        <BasePopup open={openEdit} onOpenChange={setIsOpenEdit} children={<CalendarTaskForm task={task}/>}/>

    </button>
}


function TaskPopUpData(props) {
    const {task, onOpenChange, onTaskEditingChange, onOpenEditChange} = props;
    const {deleteCalendarData} = useCalendarDataMutations();
    return <div className={"rounded-2 m-2 p-1"}>
        <Row>
            <Col xs={10}>
                <TaskData title={"Titel: "} data={task.title}/>
            </Col>
            <IfLoggedIn>
                <IfAdmin>
                    <Col className={"text-end"}>
                        <IconButton onClick={() => {
                            onOpenEditChange(true);
                            onTaskEditingChange(task);
                        }}>
                            <BiEdit style={{width: '35px', height: '35px'}}/>
                        </IconButton>
                        <IconButton onClick={async () => {
                            // eslint-disable-next-line no-restricted-globals
                            const confirmed = confirm("Verwijder dit item?");
                            if (confirmed) {
                                deleteCalendarData(task);
                              
                            }
                        }}>
                            <MdDelete style={{width: '35px', height: '35px'}}/>
                        </IconButton>
                    </Col>
                </IfAdmin>
            </IfLoggedIn>
        </Row>

        <TaskData title={"Datum: "} data={new Date(task.date).toLocaleDateString('nl-BE')}/>
        <TaskData title={"Locatie: "} data={task.location}/>
        <TaskData title={"Omschrijving: "} isHtml={true} data={task.description}/>
    </div>
}

